import Page from './page.vue';
export default Page;


// WEBPACK FOOTER //
// ./src/components/paging/index.js